import { Col, Row, Tooltip } from "antd";
import { Button, Empty } from "antd-v5";
import React, { useState } from "react";
import EqButton from "../../custom/eqButton/EqButton";
import { getDefaultImage, imageType } from "../../shared/Common";
import "./EqstudentInvitations.scss";
import { useTranslation } from "react-i18next";
//import { CourseLessonOrderEnt } from "../../shared/interfaces/ridingCourse/IRidingCourse";
import { IEqUiEventInvite, IEqUiProfile } from "../../shared/interfaces/IEqEventDto";
import { CourseLessonOrderEnt } from "../../shared/general/IStudentUnpaidOrders";
import { EqEntityTrainerStudent } from "../../shared/interfaces/IUserInfoDto";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { CourseOrderType } from "../../shared/enums";
import moment from "moment";
import { EqIconPrice } from "../../custom/eqIcon/EqIcons";

interface StudentEventInvite {
    id: string;
    firstName: string;
    lastName: string;
    userName: string;
    userImage: string;
    numberOfInvitations: number;
}

interface ProductInvitation {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    numberOfProducts: number;
    imageUrl: string;
}
interface CardProps {
    Productinvitations: ProductInvitation[];
    TrainingInvitratoin: IEqUiEventInvite[];
    SchoolPenInvitation: IEqUiProfile[];
    TrainerPenInvitation: EqEntityTrainerStudent[];
    courseInvitation: CourseLessonOrderEnt[];
    onRejectCourseInvite: (arg: object) => void;
    onAcceptCourseInvite: (arg: any) => void
    onRejectProduct: (arg: object) => void;
    onAcceptSchoolInvite: (arg: object) => void;
    onRejectSchoolInvite: (arg: object) => void;
    onAcceptTrainingInvitations: (arg: object) => void;
    onRejectTrainingInvite: (arg: object) => void;
    onAcceptTrainer: (arg: object) => void;
    onRejectTrainer: (arg: object) => void;
    onAcceptProductClick : (arg: object) => void;
}

const EqstudentInvitations: React.FC<CardProps> = (
    {
        Productinvitations,
        TrainingInvitratoin,
        SchoolPenInvitation,
        TrainerPenInvitation,
        courseInvitation,
        onAcceptTrainer,
        onRejectTrainer,
        onRejectCourseInvite,
        onAcceptCourseInvite,
        onRejectProduct,
        onAcceptSchoolInvite,
        onRejectSchoolInvite,
        onAcceptProductClick,
        onAcceptTrainingInvitations,
        onRejectTrainingInvite,
    }) => {
    const { t } = useTranslation();
    console.log("The Trainer Pending Invitation is", SchoolPenInvitation);
    const [selectedTab, setSelectedTab] = useState<string>("Training");
    const [showAllTraining, setShowAllTraining] = useState(false);
    const [showAllProduct, setShowAllProduct] = useState(false);
    const [showAllCourse, setShowAllCourse] = useState(false);
    const [showAllTrainer, setShowAllTrainer] = useState(false);
    const [showAllSchool, setShowAllSchool] = useState(false);
    const [showAll, setShowAll] = useState(false); // Single state for both trainers and schools
    const displayedProduct = showAllProduct ? Productinvitations : Productinvitations.slice(0, 3);
    const displayCourse = showAllCourse ? courseInvitation : courseInvitation.slice(0, 3);
    const displayTrainer = showAll ? TrainerPenInvitation : TrainerPenInvitation.slice(0, 2);
    const displaySchool = showAll ? SchoolPenInvitation : SchoolPenInvitation.slice(0, 2);    
    // Flatten invitations while keeping the organizer reference
const allEventsWithOrganizer = TrainingInvitratoin?.flatMap((invitation:any) => 
    invitation.events.map((event:any) => ({ ...event, organizer: invitation.organizer }))
) || [];

// Display all events if showAllTraining is true, otherwise limit to 4
const displayedTraining = showAllTraining ? allEventsWithOrganizer : allEventsWithOrganizer.slice(0, 3);

    return (
        <div className="eq-dash-student-invitations">
            <div className="card-header">
                <h3>{t("invitations")}</h3>
            </div>
            <Row className="card-tab">
                <Col
                    className={`training-tab ${selectedTab === "Training" ? "selected" : ""}`}
                    onClick={() => setSelectedTab("Training")}
                >
                    {t("trainingInvitations")}
                </Col>
                <Col
                    className={`training-tab ${selectedTab === "Product" ? "selected" : ""}`}
                    onClick={() => setSelectedTab("Product")}
                >
                    {t("productInvitations")}
                </Col>
                <Col
                    className={`training-tab ${selectedTab === "Connections" ? "selected" : ""}`}
                    onClick={() => setSelectedTab("Connections")}
                >
                    {t("connections")}
                </Col>
                <Col
                    className={`training-tab ${selectedTab === "CourseInvitation" ? "selected" : ""}`}
                    onClick={() => setSelectedTab("CourseInvitation")}
                >
                    {t("courseInvitations")}
                </Col>
            </Row>

            <div className="card-body">

                  {/* Training Invitations */}
                  {selectedTab === "Training" && (
                    <>
                        {TrainingInvitratoin && TrainingInvitratoin.length > 0 ? (
                            <>
                                {displayedTraining.map((event: any) => (
                                    <div key={event.id} className="invitation-item">
                                        <Row justify="space-between" align="middle">
                                            <Col span={20}>
                                            {/* <Tooltip placement="topLeft" title={event.event.title}> */}

                                                <Row align="middle">
                                                    <Col>
                                                        <div className="cover-div">
                                                            <img
                                                                src={event.organizer?.userImage?.url || getDefaultImage(imageType.trainer)}
                                                                alt="Sender"
                                                                className="product-image"
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="invitation-title">{event.event.title}</div>
                                                        <div>{moment(event.event.startTime).format("DD MMM YYYY HH:mm")} <EqIconPrice eqWidth="15" eqHeight="13" eqFill="#b5b5b5" />{event.event.price}</div>
                                                    </Col>
                                                </Row>
                                                {/* </Tooltip> */}
                                            </Col>
                                            <Col span={4} className="action-col">
                                           

                                                <Button
           onClick={() =>onAcceptTrainingInvitations &&  onAcceptTrainingInvitations(event)}
           className="invite-accept-btn"
           size="small"
           shape="circle"
           icon={<CheckOutlined />}
         />
         <Button
           onClick={() =>onRejectTrainingInvite &&  onRejectTrainingInvite(event)}
           className="invite-reject-btn"
           size="small"
           shape="circle"
           icon={<CloseOutlined />}
         />
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                                  {(TrainingInvitratoin?.reduce((acc: any, invitation: any) => acc + (invitation.events?.length || 0), 0) > 3) && (
                                 <h3 className="showAll-click" onClick={() => setShowAllTraining(!showAllTraining)}>
                                     {showAllTraining ? t("showLess") : t("showAll")}
                                 </h3>
                             )}
                            </>
                        ) : (
                            <Empty description={t("noDataAvailable")} />
                        )}
                    </>
                )}
                {/* Product Invitations */}
                {selectedTab === "Product" && (
                    <>
                        {Productinvitations.length > 0 ? (
                            <>
                                {displayedProduct?.map((invitation: any) => (
                                    <div key={invitation.id} className="invitation-item">
                                        <Row justify="space-between" align="middle">
                                            <Col span={22}>
                                                <Row align="middle">
                                                    <Col>
                                                        <div className="cover-div">
                                                            <img
                                                                src={invitation.product?.imageUrl || "default-image-url"}
                                                                alt="Product"
                                                                className="product-image"
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="invitation-title">
                                                            {invitation.product?.title}
                                                        </div>
                                                        <div>{t("from")} {invitation.product?.user?.email}</div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={2} className="action-col">
                                      

                                                
                                                <Button
           onClick={() =>onAcceptProductClick &&  onAcceptProductClick(invitation)}
           className="invite-accept-btn"
           size="small"
           shape="circle"
           icon={<CheckOutlined />}
         />
         <Button
           onClick={() =>onRejectProduct &&  onRejectProduct(invitation)}
           className="invite-reject-btn"
           size="small"
           shape="circle"
           icon={<CloseOutlined />}
         />
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                                {Productinvitations.length > 3 && (
                                    <h3 className="showAll-click" onClick={() => setShowAllProduct(!showAllProduct)}>
                                        {showAllProduct ? t("showLess") : t("showAll")}
                                    </h3>
                                )}
                            </>
                        ) : (
                            <Empty description={t("noDataAvailable")} />
                        )}
                    </>
                )}

              

                {/* Connections */}
                {selectedTab === "Connections" && (
                    <>
                        {(SchoolPenInvitation.length > 0 || TrainerPenInvitation.length > 0) ? (
                            <>
                                {SchoolPenInvitation.length > 0 && (
                                    <div className="connection-section">
                                        {displaySchool.map((item: any) => (
                                            <div key={item.id} className="invitation-item">
                                                <Row justify="space-between" align="middle">
                                                    <Col span={22}>
                                                        <Row align="middle">
                                                            <Col>
                                                                <div className="cover-div">
                                                                    <img
                                                                        src={item.userImage?.url || getDefaultImage(imageType.trainer)}
                                                                        alt="Sender"
                                                                        className="product-image"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col>
                                                                <div className="invitation-title">
                                                                    {item.firstName} {item.lastName}
                                                                </div>
                                                                <div>{item.email}</div>
                                                                <div className="invitation-type">{t("school")}</div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col span={2} className="action-col">
                                                   

                                                        <Button
           onClick={() =>onAcceptSchoolInvite &&  onAcceptSchoolInvite(item)}
           className="invite-accept-btn"
           size="small"
           shape="circle"
           icon={<CheckOutlined />}
         />
         <Button
           onClick={() =>onRejectSchoolInvite &&  onRejectSchoolInvite(item)}
           className="invite-reject-btn"
           size="small"
           shape="circle"
           icon={<CloseOutlined />}
         />
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {TrainerPenInvitation.length > 0 && (
                                    <div className="connection-section">
                                        <div className="divider-line"></div>
                                        {displayTrainer.map((item: any) => (
                                            <div key={item.id} className="invitation-item">
                                                <Row justify="space-between" align="middle">
                                                    <Col span={22}>
                                                        <Row align="middle">
                                                            <Col>
                                                                <div className="cover-div">
                                                                    <img
                                                                        src={item?.userImage.url || getDefaultImage(imageType.trainer)}
                                                                        alt="Sender"
                                                                        className="product-image"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col>
                                                                <div className="invitation-title">
                                                                    {item.firstName} {item.lastName}
                                                                </div>
                                                                <div >{item.email}</div>
                                                                <div className="invitation-type">{t("trainer")}</div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col span={2} className="action-col">
                                                    

                                                        <Button
           onClick={() =>onAcceptTrainer &&  onAcceptTrainer(item)}
           className="invite-accept-btn"
           size="small"
           shape="circle"
           icon={<CheckOutlined />}
         />
         <Button
           onClick={() =>onRejectTrainer &&  onRejectTrainer(item)}
           className="invite-reject-btn"
           size="small"
           shape="circle"
           icon={<CloseOutlined />}
         />
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {(SchoolPenInvitation.length > 2 || TrainerPenInvitation.length > 2) && (
                                    <h3 className="showAll-click" onClick={() => setShowAll(!showAll)}>
                                        {showAll ? t("showLess") : t("showAll")}
                                    </h3>
                                )}
                            </>
                        ) : (
                            <Empty description={t("noDataAvailable")} />
                        )}
                    </>
                )}

                {/* Course Invitations */}
                {selectedTab === "CourseInvitation" && (
                    <>
                        {displayCourse.length > 0 ? (
                            <>
                                <div className="connection-section">
                                    {displayCourse.map((item, index) => (
                                        <React.Fragment key={item.id}>
                                            <div className="invitation-item">
                                                <Row justify="space-between" align="middle">
                                                    <Col span={22}>
                                                        <Row align="middle">
                                                            <Col>
                                                               
                                                                    <img
                                                                        src={item.orderType === CourseOrderType.FullCourse
                                                                            ? item?.course?.image?.url || getDefaultImage(imageType.events)
                                                                            : item.courseLesson?.course?.image?.url || getDefaultImage(imageType.events)}
                                                                        alt="Course"
                                                                        className="product-image"
                                                                    />
                                                                
                                                            </Col>
                                                            <Col>
                                                                <div className="course-invitations">
                                                                    <div className="invitation-title">
                                                                        {/* {t("course")} */}
                                                                        {item.orderType === CourseOrderType.FullCourse
                                                                            ? item.course?.title
                                                                            : item.courseLesson?.course?.title}
                                                                    </div>
                                                                    <div>
                                                                        {t("from")}{" "}
                                                                        {item.orderType === CourseOrderType.FullCourse
                                                                            ? item.course?.createdBy?.email
                                                                            : item.courseLesson?.course?.createdBy?.email}
                                                                    </div>
                                                                </div>
                                                                <p className="invitation-message">
                                                                    {item.orderType === CourseOrderType.FullCourse
                                                                        ? t("invitesYouToCourse")
                                                                        : t("invitesYouToCourseLesson")}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col span={2} className="action-col">
                                                     

                                                        
                                                        <Button
           onClick={() =>onAcceptCourseInvite &&  onAcceptCourseInvite(item)}
           className="invite-accept-btn"
           size="small"
           shape="circle"
           icon={<CheckOutlined />}
         />
         <Button
           onClick={() =>onRejectCourseInvite &&  onRejectCourseInvite(item)}
           className="invite-reject-btn"
           size="small"
           shape="circle"
           icon={<CloseOutlined />}
         />
                                                    </Col>
                                                </Row>
                                            </div>
                                            {index < courseInvitation.length - 1 && <></>}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <Empty description={t("noDataAvailable")} />
                        )}
                        {courseInvitation.length > 4 && (
                            <h3 className="showAll-click" onClick={() => setShowAllCourse(!showAllCourse)}>
                                {showAllCourse ? t("showLess") : t("showAll")}
                            </h3>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
export default EqstudentInvitations;